import { useTranslation } from 'react-i18next';
import { tokens } from '@fluentui/react-theme';
import { Text, Title3 } from "@fluentui/react-components";
import styles from './Page.module.scss';
import successImage from '../assets/alone-time-bg.png';
import laptopImage from '../assets/laptop-bg.png';

export default function Page(props: { title: string, content: string | JSX.Element, imageSrc?: string }) {

    return (
        <div>
            {props.imageSrc && (
                <div className={styles.imageContainer} style={{
                    backgroundColor: tokens.colorPaletteMarigoldBackground2
                }}>
                    <img className={styles.image} src={props.imageSrc} alt='Test'></img>
                </div>
            )}
            <div className={styles.contentContainer}>
                <Title3 className={styles.title}>{props.title}</Title3>
                <Text align='center' size={400}>{props.content}</Text>
            </div>
        </div>
    );
}

export function SuccessPage(props: {}) {
    const { t } = useTranslation();
    return <Page title={t("auth.success.title")} content={t("auth.success.message")} imageSrc={successImage}></Page>;
}

export function CancelPage(props: {}) {
    const { t } = useTranslation();
    return <Page title={t("auth.cancel.title")} content={t("auth.cancel.message")} imageSrc={laptopImage}></Page>;
}

export function InvalidStateErrorPage(props: {}) {
    const { t } = useTranslation();
    return <Page title={t("auth.error.title")} content={t("auth.error.noStateMatch")} imageSrc={laptopImage}></Page>;
}

export function NotInAppErrorPage(props: {}) {
    const { t } = useTranslation();
    return <Page title={t("auth.error.title")} content={t("auth.error.outsideOfApp")} imageSrc={laptopImage}></Page>;
}